/**
 * Sends the customer to an external URL as a normal, top-level navigation.
 * If the page happens to be rendered inside a frame, the parent window is
 * navigated instead so the Shopify checkout never loads inside an iframe.
 */
export function redirectTop(url: string): void {
  try {
    if (window.top && window.top !== window.self) {
      window.top.location.href = url
      return
    }
  } catch {
    // Cross-origin parent: fall through to a normal navigation.
  }
  window.location.href = url
}
